<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
    <g>
      <path
        d="M11.159,33.807C2.153,30.306-2.307,20.166,1.193,11.157C4.696,2.152,14.837-2.309,23.841,1.195
		c9.006,3.498,13.466,13.644,9.966,22.646C30.304,32.848,20.163,37.308,11.159,33.807"
      />
      <g>
        <path
          fill="#FFFFFF"
          d="M22.271,16.381c-0.052,0.017-0.29,0.175-0.5,0.314c-0.808,0.537-2.312,1.537-4.271,1.537
			s-3.463-1-4.271-1.537c-0.21-0.14-0.448-0.298-0.523-0.316c-3.727,0.002-4.286,4.598-4.286,7.337c0,1.942,1.248,3.149,3.258,3.149
			h11.645c2.01,0,3.258-1.207,3.258-3.149C26.58,20.977,26.021,16.381,22.271,16.381z"
        />
        <path
          fill="#FFFFFF"
          d="M17.5,16.634c2.655,0,4.816-2.161,4.816-4.817C22.316,9.161,20.155,7,17.5,7s-4.816,2.161-4.816,4.816
			C12.684,14.473,14.845,16.634,17.5,16.634z"
        />
      </g>
    </g>
  </svg>
</template>